import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { calculateRem } from '@uie/javascript-style-helpers';
import { Body as CoreBody } from '@vds-core/typography';
import { colors } from '@vds-core/theme';
import { withVDSManager } from '@vds-core/utilities';
var propTypes = {
  /**
   * Children for the AccordionTitle can be any type.
   */
  children: PropTypes.node.isRequired,

  /**
   * @deprecated
   */
  className: PropTypes.string,

  /**
   * Add this prop if you want your accordion to have an inverted color scheme.
   */
  inverted: PropTypes.bool,

  /**
   * @ignore
   * Pass in a title component
   */
  typographyComponent: PropTypes.func,

  /**
   * @Ignore
   * Pass in a title component size
   */
  typeSize: PropTypes.string,

  /**
   * Set the styling of the component to the desktop, tablet, or mobile size based on passed prop.
   * Desktop and tablet are the same size.
   */
  viewport: PropTypes.oneOf(['desktop', 'mobile', 'tablet']),

  /**
   * @ignore
   * Object containing hex colors
   */
  colorConfig: PropTypes.object
};
var defaultProps = {
  inverted: false,
  className: null,
  viewport: 'desktop',
  typographyComponent: CoreBody,
  typeSize: 'medium',
  colorConfig: colors
};

var AccordionSubTitle = function AccordionSubTitle(props) {
  var typeSize = props.typeSize,
      typographyComponent = props.typographyComponent,
      colorConfig = props.colorConfig,
      inverted = props.inverted;
  var AccordionSubTitleStyled = typographyComponent;
  return /*#__PURE__*/React.createElement(AccordionSubTitleStyled, _extends({
    inverted: props.inverted,
    viewport: props.viewport,
    color: inverted ? colorConfig.white : colorConfig.black,
    size: typeSize
  }, props), props.children);
};

AccordionSubTitle.propTypes = propTypes;
AccordionSubTitle.defaultProps = defaultProps;
AccordionSubTitle.displayName = 'AccordionSubTitle';
export default AccordionSubTitle;